export default __webpack_public_path__ + "static/media/4.ff24ab6d.png";